import api from 'app/api';
import revalidatePageByDomainName from './revalidate-page-by-domain-name';

export const documentsApi = api.injectEndpoints({
    endpoints: (builder) => ({
        revalidatePageByDomain: revalidatePageByDomainName(builder),
    }),
});

export const { useRevalidatePageByDomainMutation } = documentsApi;
